//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventColorEnum, PayrollOverrideType } from './Enums';

export class EventCategoryUpdateItem extends ItemBase {
    AllowMakeUpCredits?: boolean;
    BlocksOtherRecurringEvents?: boolean;
    Color?: EventColorEnum;
    EmailReminderHours?: number | null;
    Name?: string | null;
    PayrollOverride?: PayrollOverrideType;
    PayrollOverrideAmount?: number;
    SMSReminderHours?: number | null;

    constructor(initializer?: Partial<EventCategoryUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "EventCategoryUpdateItem";
}
